import React from "react";
import "./Terms.css";
import { useEffect } from "react";
const TermsOfService = () => {
    useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  return (
    <div className="terms-wrapper">
      <div className="terms-container">

        <h1>Terms of Service</h1>
        <p className="effective-date">
          Effective Date: January 1, 2026
        </p>

        <p className="intro-text">
          By accessing or using Forge Your Peak ("we", "our", or "us") website,
          games, performance tests, dashboards, and training programs, you
          agree to be bound by these Terms of Service.
        </p>

        <hr />

        {/* 1 */}
        <h2>1. Eligibility</h2>
        <p>
          You must be at least 18 years old to use our services independently.
          Minors may use the platform under parental or institutional
          supervision and consent.
        </p>

        {/* 2 */}
        <h2>2. Use of Services</h2>
        <ul>
          <li>You agree to use the platform only for lawful purposes.</li>
          <li>
            You agree not to misuse, reverse engineer, copy, or redistribute
            proprietary tools or software.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            login credentials.
          </li>
        </ul>

        {/* 3 */}
        <h2>3. Performance Disclaimer</h2>
        <p>
          Our tools measure performance metrics such as reaction speed and
          visual acuity. Results may vary based on individual effort, health,
          training consistency, and external conditions. We do not guarantee
          specific performance outcomes.
        </p>

        {/* 4 */}
        <h2>4. Payments & Access</h2>
        <p>
          Paid programs grant access to specified services or membership
          levels. Access may be revoked if terms are violated. Payments are
          processed through secure third-party providers.
        </p>

        {/* 5 */}
        <h2>5. Intellectual Property</h2>
        <p>
          All content, software, branding, training frameworks, and
          measurement systems are the intellectual property of Forge Your
          Peak and may not be copied, reproduced, or distributed without
          written permission.
        </p>

        {/* 6 */}
        <h2>6. Limitation of Liability</h2>
        <p>
          Forge Your Peak shall not be liable for any indirect, incidental,
          or consequential damages arising from the use of our services.
          Use of the platform is at your own risk.
        </p>

        {/* 7 */}
        <h2>7. Termination</h2>
        <p>
          We reserve the right to suspend or terminate accounts that violate
          these Terms.
        </p>

        {/* 8 */}
        <h2>8. Modifications</h2>
        <p>
          We may update these Terms from time to time. Continued use of the
          platform after updates constitutes acceptance of the revised Terms.
        </p>

        {/* 9 */}
        <h2>9. Governing Law</h2>
        <p>
          These Terms shall be governed by and interpreted in accordance with
          the laws applicable in your operating jurisdiction.
        </p>

        {/* 10 */}
        <h2>10. Contact</h2>
        <p>
          For questions regarding these Terms, contact:
        </p>
        <p className="email">support@forgeyourpeak.com</p>

      </div>
    </div>
  );
};

export default TermsOfService;